import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CardImageFooterA from 'components/CardImageFooter/CardImageFooterA';
import classes from './CardImageE.module.scss';

const CardImageE = (props) => {
  const {
    color,
    heading,
    contentMarkup,
    links,
    buttons,
    listType,
  } = props;

  const footerChildren = listType === 'Links' ? links : buttons;

  return (
    <div className={classes.container}>
      {heading &&
        <div className={classNames(classes.titleContainer, `bg-${color}`)}>
          <h2
            className={classes.title}
            dangerouslySetInnerHTML={{ __html: heading }}
          />
        </div>}
      {(contentMarkup || footerChildren.length > 0) &&
        <div className={classes.content}>
          {contentMarkup &&
            <div
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: contentMarkup }}
            />}
          <CardImageFooterA
            classes={classes}
            footerChildren={footerChildren}
            containerKey='CardImageE-footerChildren'
          />
        </div>}
    </div>
  );
};

CardImageE.propTypes = {
  /**
   * Background Color for the Heading
  */
  color: PropTypes.string,
  /**
   * Heading on the card
  */
  heading: PropTypes.string,
  /**
   * Content of the card
  */
  contentMarkup: PropTypes.string,
  /**
   * List of links<br>
   * Only used when `listType` = `Links`
  */
  links: PropTypes.array,
  /**
   * List of buttons<br>
   * Only used when `listType` = `Buttons`
  */
  buttons: PropTypes.array,
  /**
    * Type of list<br>
    * Options: `Buttons` `Links`
  */
  listType: PropTypes.string,
};

export default CardImageE;
